import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

import "./style.css";
import AssessmentFailed from "./views/assessment-failed";
import Home from "./views/home";
import BusinessFundingPage from "./views/business-funding-page";
import VehicleRentPage from "./views/vehicle-rent-page";
import NotFound from "./views/not-found";

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <Switch>
          <Route exact path="/assessment-failed">
            <Helmet>
              <title>Assessment Failed | HelpMeOut</title>
              <meta
                name="description"
                content="Sorry, your assessment was not successful. Learn more about HelpMeOut micro-loans."
              />
            </Helmet>
            <AssessmentFailed />
          </Route>

          <Route exact path="/">
            <Helmet>
              <title>Quick Micro Loans South Africa | HelpMeOut</title>
              <meta
                name="description"
                content="Need a fast micro-loan in South Africa? Apply online with HelpMeOut for instant approval and flexible repayment options."
              />
            </Helmet>
            <Home />
          </Route>

          <Route exact path="/business-funding-page">
            <Helmet>
              <title>Business Funding Solutions South Africa | HelpMeOut</title>
              <meta
                name="description"
                content="Apply for business funding in South Africa. HelpMeOut provides fast, reliable micro-loans for your business needs."
              />
            </Helmet>
            <BusinessFundingPage />
          </Route>

          <Route exact path="/vehicle-rent-page">
            <Helmet>
              <title>Vehicle Rent-to-Own Solutions | HelpMeOut</title>
              <meta
                name="description"
                content="Get vehicles with rent-to-own options. HelpMeOut offers flexible financing for your vehicle needs."
              />
            </Helmet>
            <VehicleRentPage />
          </Route>

          <Route path="*">
            <Helmet>
              <title>Page Not Found | HelpMeOut</title>
              <meta
                name="description"
                content="The page you are looking for does not exist. Navigate back to HelpMeOut for micro-loans, business funding, and vehicle financing."
              />
            </Helmet>
            <NotFound />
          </Route>

          <Redirect to="*" />
        </Switch>
      </Router>
    </HelmetProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("app"));
